var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVtqVertGrande(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 518.59 280.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#211915;}.cls-2{fill:#cd6903;}.cls-3{fill:#e5b300;}.cls-4{fill:#da9300;}.cls-5{fill:#d17600;}.cls-6{fill:#d48000;}.cls-7{fill:#de9f00;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.23 170.19 31.19 210.53 23.04 210.53 0 170.19 7.92 170.19 27.11 203.81 46.31 170.19 54.23 170.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "94.17 210.53 54.63 210.53 54.63 174.91 92.71 174.91 92.71 180.22 60.89 180.22 60.89 189.38 83.01 189.38 83.01 194.69 60.89 194.69 60.89 205.22 94.17 205.22 94.17 210.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "138.36 180.22 120.31 180.22 120.31 210.53 114.05 210.53 114.05 180.22 96 180.22 96 174.91 138.36 174.91 138.36 180.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "182.91 210.53 143.37 210.53 143.37 174.91 181.45 174.91 181.45 180.22 149.62 180.22 149.62 189.38 171.74 189.38 171.74 194.69 149.62 194.69 149.62 205.22 182.91 205.22 182.91 210.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.85,191.63q7.25,0,7.25-5.5,0-5.91-7.82-5.91h-22v11.41Zm14,18.9h-7.29L215.33,197H196.26v13.58H190V174.91h29.79q5.94,0,9.33,3a10.41,10.41,0,0,1,3.39,8.2,9.79,9.79,0,0,1-2.76,7.28,12.29,12.29,0,0,1-7,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.93,204.59q9.15-3.5,9.14-12,0-6.26-5.68-10.19a20.64,20.64,0,0,0-12-3.35,20.9,20.9,0,0,0-12.1,3.36q-5.7,3.89-5.69,10.19a11.77,11.77,0,0,0,4.87,9.77q4.89,3.75,12.91,3.75c.39,0,1.14,0,2.24-.09l-4.05-4.29,6-1.69Zm-1.65,6.2a34.21,34.21,0,0,1-6.89.73q-9.91,0-16.64-4.78-7.67-5.44-7.67-14.12t7.72-14.07q6.78-4.83,16.59-4.82t16.54,4.81q7.67,5.46,7.67,14.06,0,11-11.49,16.33l4.7,4.88-5.89,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.23,199q0,5.56-5.74,9t-15.59,3.59q-9.76,0-15.7-3.59-5.74-3.5-5.75-9V174.91h6.27v22.68A7,7,0,0,0,296.6,204c2.59,1.49,6.36,2.22,11.3,2.22s8.68-.73,11.24-2.22a7,7,0,0,0,3.83-6.39V174.91h6.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 337.16,
    y: 174.91,
    width: 6.26,
    height: 35.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "404.56 210.53 398.3 210.53 398.3 181.41 398.14 181.41 378.53 204.63 359.07 181.41 358.92 181.41 358.92 210.53 352.65 210.53 352.65 174.91 360.48 174.91 378.58 196.44 396.76 174.91 404.56 174.91 404.56 210.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 413.8,
    y: 174.91,
    width: 6.26,
    height: 35.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.28,183,465.59,185q-5.73-5.76-16.06-5.76-7.83,0-12.76,3.79a12.05,12.05,0,0,0,0,19.41q4.88,3.72,13.17,3.72,10,0,15.75-5.87l5.37,2.82a24.16,24.16,0,0,1-9.2,6.46,33.91,33.91,0,0,1-12.28,2q-10,0-16.65-4.72-7.56-5.42-7.56-14.18,0-8.61,7.67-14.07,6.67-4.77,16.54-4.78,14.19,0,21.75,9.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M504.35,197.25,494.73,180,485,197.25Zm14.24,13.28h-6.84l-4.36-8H482l-4.35,8h-6.84l20-35.62h7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.29,229.1a5.11,5.11,0,0,0-.63-3.15,3.6,3.6,0,0,0-2.44-.93,3.39,3.39,0,0,0-3.27,1.67c-.09.25-.63.79-.63,4.5V237c0,5.32,1.74,6,3.87,6,.84,0,3.39-.29,3.43-4.53h2.84c.13,6.83-4.7,6.83-6.12,6.83-2.7,0-6.84-.17-6.84-8.57v-6.12c0-6.13,2.7-7.86,7-7.86s6,2.21,5.67,6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.12,232.43h4.15c2,0,2.93-1.72,2.93-3.6,0-1.56-.77-3.31-2.91-3.31h-4.17Zm0,2.4v10h-2.76V223.12h7.48c3.84,0,5.18,2.7,5.18,5.41a4.67,4.67,0,0,1-4,4.95v.05c2.49.4,3.39,1.24,3.54,5.59a34,34,0,0,0,.74,5.68h-2.88c-.77-1.51-.59-4.33-.83-7.21-.21-2.64-2.35-2.76-3.28-2.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "130.11 244.79 130.11 223.12 141.28 223.12 141.28 225.52 132.87 225.52 132.87 232.49 140.67 232.49 140.67 234.88 132.87 234.88 132.87 242.39 141.45 242.39 141.45 244.79 130.11 244.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.68,225.68h-.05l-3.4,11.54h6.94ZM150,223.12h3.5l7.06,21.68h-3.1l-1.56-5.17h-8.37l-1.62,5.17h-2.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "178.44 223.12 178.44 244.8 174.67 244.8 166.12 226 166.06 226 166.06 244.8 163.6 244.8 163.6 223.12 167.5 223.12 175.93 241.67 175.99 241.67 175.99 223.12 178.44 223.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.28,242.39h2.62c3.84,0,5.25-1.44,5.25-6.48v-4.38c0-4.38-1.36-6-4.24-6h-3.63Zm-2.76-19.27h6.66c2.76,0,4.74,1,5.83,3.31.87,1.82,1,6.14,1,6.84,0,4.61-.41,7.29-1.32,8.73-1.16,1.87-3.35,2.8-7.14,2.8h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.51,237v-7.31c0-4.54-3.12-4.68-4-4.68s-4,.14-4,4.68V237c0,4.75,1.39,6,4,6s4-1.2,4-6m-10.81-.11v-7.11c0-4.33,2.22-7.08,6.82-7.08s6.81,2.75,6.81,7.08v7.11c0,6-2.22,8.36-6.81,8.36s-6.82-2.35-6.82-8.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.92,238.34V239c0,2.94,1.86,3.86,3.63,3.86,2.19,0,3.88-.92,3.88-3.5,0-4.8-9.73-4.27-9.73-10.77,0-3.85,2.73-5.88,6.36-5.88,4,0,6.18,1.92,6,6.33h-2.89c0-2.37-.72-3.93-3.33-3.93a3,3,0,0,0-3.33,3.17c0,4.78,9.72,4.08,9.72,11,0,4.56-3.14,6-6.73,6-6.38.08-6.38-4.82-6.32-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.05,225.68H250l-3.38,11.54h6.93Zm-1.68-2.56h3.51l7.05,21.68h-3.09l-1.56-5.17h-8.37l-1.63,5.17h-2.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "261.81 244.79 261.81 223.12 264.56 223.12 264.56 242.39 272.53 242.39 272.53 244.79 261.81 244.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275,223.12h2.76V237c0,4.75,1.44,6,4.06,6s4.05-1.2,4.05-6V223.12h2.76v13.75c0,6-2.22,8.36-6.81,8.36s-6.82-2.36-6.82-8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.29,242.39h2.61c3.84,0,5.25-1.44,5.25-6.48v-4.38c0-4.38-1.35-6-4.23-6h-3.63Zm-2.76-19.27h6.66c2.77,0,4.74,1,5.82,3.31.87,1.82,1,6.14,1,6.84,0,4.61-.42,7.29-1.32,8.73-1.17,1.87-3.36,2.8-7.14,2.8h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,225.68h0l-3.4,11.54h6.94Zm-1.68-2.56h3.52l7.05,21.68h-3.09l-1.57-5.17h-8.37l-1.62,5.17h-2.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "351.81 223.12 351.81 244.8 348.02 244.8 339.46 226 339.41 226 339.41 244.8 336.95 244.8 336.95 223.12 340.86 223.12 349.29 241.67 349.35 241.67 349.35 223.12 351.81 223.12"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 357.17,
    y: 223.12,
    width: 2.77,
    height: 21.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "367.76 244.79 365.18 244.79 365.18 223.12 369.65 223.12 375.11 241.3 375.17 241.3 380.7 223.12 385.26 223.12 385.26 244.79 382.5 244.79 382.5 225.52 382.45 225.52 376.38 244.79 373.77 244.79 367.82 225.52 367.76 225.52 367.76 244.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.72,225.68h-.06l-3.4,11.54h6.95ZM395,223.12h3.51l7.05,21.68h-3.09L401,239.63h-8.37L391,244.8h-2.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "408.49 244.79 408.49 223.12 411.25 223.12 411.25 242.39 419.2 242.39 419.2 244.79 408.49 244.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.59,263.08a706.13,706.13,0,0,1,79.19-2.85c13.68.32,27.37,1.11,40.69,2.62,5.84.65,11.75,1.29,17.36,2.32,3,.55,13.36,2.94,14.61.61.33-.61-2.53-1.76-4-2.29-15.3-5.7-35.87-7.79-54.51-8.63-29.25-1.3-58.94.49-87.62,3.34-30,3-59.69,7.93-86.43,15.43-3.7,1-7.35,2.14-10.92,3.29-2.38.77-8.61,2.89-9,3.68,2,0,6.45-1.66,8.77-2.25,3.29-.87,6.62-1.69,10-2.49q10.44-2.48,21.25-4.57c15.08-2.93,30.61-5,46.43-6.78q7-.79,14.16-1.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M236.94,119.39a21.4,21.4,0,1,0-21.41,21.37,21.43,21.43,0,0,0,21.41-21.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M279.9,119.39a21.38,21.38,0,1,0-21.38,21.37,21.4,21.4,0,0,0,21.38-21.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M322.91,119.39a21.4,21.4,0,1,0-21.38,21.37,21.4,21.4,0,0,0,21.38-21.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.94,76.54a21.4,21.4,0,1,0-21.41,21.38,21.39,21.39,0,0,0,21.41-21.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M279.9,76.54a21.38,21.38,0,1,0-21.38,21.38A21.35,21.35,0,0,0,279.9,76.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M322.91,76.54a21.4,21.4,0,1,0-21.38,21.38,21.36,21.36,0,0,0,21.38-21.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M236.94,33.69A21.4,21.4,0,1,0,215.53,55.1a21.43,21.43,0,0,0,21.41-21.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.9,33.69A21.38,21.38,0,1,0,258.52,55.1,21.4,21.4,0,0,0,279.9,33.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M335.17,21.41A21.38,21.38,0,1,0,313.8,42.8a21.38,21.38,0,0,0,21.37-21.39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVtqVertGrande);
export default __webpack_public_path__ + "static/media/logo-vtq-vert-grande.875f11eed94f4c5c9584a1a5013ae9a6.svg";
export { ForwardRef as ReactComponent };